import React from 'react';

const TeamCTA = ({ onLearnMore }) => {
  return (
    <section className="team-cta-section">
      <div className="team-cta-container">
        <h2 className="team-cta-title">
          Next Steps
        </h2>
        
        <div className="team-cta-buttons">
          <button
            onClick={onLearnMore}
            className="team-cta-primary"
          >
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
};

export default TeamCTA;


